// Stefans-AI-CV-frontend/src/App.tsx

import { useEffect } from 'react'
import { useAppStore } from './stores/appStore'
import Navbar from './components/Navbar'
import Hero from './sections/Hero'
import StatsSection from './sections/StatsSection'
import About from './sections/About'
import ChatSection from './sections/ChatSection'
import Experience from './sections/Experience'
import Projects from './sections/Projects'
import ResearchSection from './sections/ResearchSection'
import Footer from './sections/Footer'

export default function App() {
  const { initializeSession, loadFromStorage } = useAppStore()

  useEffect(() => {
    loadFromStorage()
    initializeSession()
  }, [])

  return (
    <div className="min-h-screen bg-bg-base text-text-primary font-body">
      <Navbar />
      <main>
        <Hero />
        <StatsSection />
        <About />
        <Projects />
        <ResearchSection />
        <Experience />
        <ChatSection />
      </main>
      <Footer />
    </div>
  )
}
